import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import axios from "../../../services/index.service";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import TopNav from "../../../components/TopNav";
import ButtomButton from "../../../components/DocButtomButton";
import CopyTypeComponent from "../components/CopyTypeComponent";
import ErrorInputComponent from "../../../components/ErrorInputComponent";
import { getDocumentProcessingFee } from "../../../actions/document.action";
import { Loading } from "../../../utils/helpers/constants";
import { fetchDocumentInstructions } from "../../../actions/document.action";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useHistory } from "react-router-dom";
import RoundLoader from "../../../components/loader/RoundLoader";
import TokenHelpers from "../../../utils/helpers/tokenHelper";
import { getAccountPathByName } from "../../../utils/helpers/getAccountTypeName";

const TranscriptType = ({ name, handleChange }) => (
  <div className="flex items-center mt-2">
    <div className="flex items-center pl-0">
      <input
        defaultChecked
        id="list-radio-license"
        type="radio"
        value="LOCAL"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-license"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        Local
      </label>
    </div>
    <div className="flex items-center pl-3">
      <input
        id="list-radio-id"
        type="radio"
        value="FOREIGN"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-id"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        Foreign
      </label>
    </div>
  </div>
);

const TranscriptDelivery = ({ name, handleChange }) => (
  <div className="flex items-center">
    <div class="flex items-center pl-0">
      <input
        defaultChecked
        id="list-radio-license"
        type="radio"
        value="WES"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-license"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        WES
      </label>
    </div>
    <div class="flex items-center pl-3">
      <input
        id="list-radio-id"
        type="radio"
        value="ETX"
        onChange={handleChange}
        name={name}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-id"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        ETX
      </label>
    </div>
    <div class="flex items-center pl-3">
      <input
        id="list-radio-millitary"
        type="radio"
        value="OTHERS"
        name={name}
        onChange={handleChange}
        className="checkbox-round mr-2 leading-tight focus:ring-green-500"
      />
      <label
        htmlFor="list-radio-millitary"
        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        Others
      </label>
    </div>
  </div>
);

const HardCopyView = ({
  errors,
  handleChange,
  values,
  setParentPhoneNumber,
  setReceiverPhoneNumber,
  setDeliveryPhoneNumber,
}) => {
  const handleOnChange = (value) => {
    setParentPhoneNumber(value);
  };

  return (
    <div>
      <TranscriptType name={"transcriptType"} handleChange={handleChange} />
      <div className="mt-5">
        <div className="font-bold">Parent's Contact Details</div>
        <input
          className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
          id="inline-full-name"
          type="name"
          name="parentName"
          onChange={handleChange}
          placeholder="Parent full name"
        />
        <ErrorInputComponent error={errors.parentName} />
        <PhoneInput
          name="parentPhoneNumber"
          country={"ng"}
          containerStyle={{
            border: "1px solid gray",
            marginTop: "10px",
            paddingTop: "5px",
            paddingBottom: "5px",
            borderRadius: "2px",
          }}
          inputStyle={{
            border: "none",
          }}
          required
          onChange={handleOnChange}
          placeholder={"Phone Number"}
        />
      </div>
      <div className="mt-3">
        <div className="font-bold">Reason for Processing Transcript</div>
        <textarea
          className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
          id="inline-full-name"
          type="textarea"
          name="reason"
          rows={5}
          placeholder="Reason"
          onChange={handleChange}
        />
        <ErrorInputComponent error={errors.reason} />
      </div>
      <div className="mt-3">
        <div className="font-bold">Transcript Delivery</div>
        {values.transcriptType === "FOREIGN" && (
          <>
            <TranscriptDelivery
              name={"transcriptDelivery"}
              handleChange={handleChange}
            />
            <ForeignComponent
              handleChange={handleChange}
              errors={errors}
              values={values}
              setDeliveryPhoneNumber={setDeliveryPhoneNumber}
            />
          </>
        )}
        {values.transcriptType === "LOCAL" && (
          <LocalComponent
            handleChange={handleChange}
            errors={errors}
            setReceiverPhoneNumber={setReceiverPhoneNumber}
          />
        )}
      </div>
    </div>
  );
};

const ForeignComponent = ({
  handleChange,
  errors,
  values,
  setDeliveryPhoneNumber,
}) => {
  const getPlaceHolder = (transcriptDelivery) => {
    if (transcriptDelivery === "ETX") {
      return "DDR";
    } else if (transcriptDelivery === "WES") {
      return "WES";
    } else {
      return "Phone Number";
    }
  };

  const getName = (transcriptDelivery) => {
    if (transcriptDelivery === "ETX") {
      return "ddr";
    } else if (transcriptDelivery === "WES") {
      return "referenceNumber";
    } else {
      return "phoneNumber";
    }
  };

  return (
    <div className="mt-2">
      <input
        className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
        id="inline-full-name"
        type="name"
        name="deliveryName"
        onChange={handleChange}
        placeholder="Name"
      />
      <ErrorInputComponent error={errors.deliveryName} />

      {values.transcriptDelivery === "OTHERS" && (
        <>
          <PhoneInput
            name="deliveryPhoneNumber"
            country={"ng"}
            containerStyle={{
              border: "1px solid gray",
              marginTop: "10px",
              paddingTop: "5px",
              paddingBottom: "5px",
              borderRadius: "2px",
            }}
            inputStyle={{
              border: "none",
            }}
            required
            onChange={(e) => setDeliveryPhoneNumber(e)}
            placeholder={"Phone Number"}
          />
          <ErrorInputComponent error={errors.deliveryPhoneNumber} />
        </>
      )}

      {values.transcriptDelivery === "ETX" ||
      values.transcriptDelivery === "WES" ? (
        <>
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="text"
            name={getName(values.transcriptDelivery)}
            onChange={handleChange}
            placeholder={getPlaceHolder(values.transcriptDelivery)}
          />
          {/* <ErrorInputComponent error={errors.referenceNumber} /> */}
        </>
      ) : null}

      {/* {values.transcriptDelivery === "WES" | values.transcriptDelivery === "OTHERS" && ( */}
      <>
        <input
          className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
          id="inline-full-name"
          type="text"
          name="receiverAddress"
          onChange={handleChange}
          placeholder="Receiver's Address"
          typeof="text"
        />
        <ErrorInputComponent error={errors.receiverAddress} />
      </>
      {/* )} */}
    </div>
  );
};

const LocalComponent = ({ handleChange, errors, setReceiverPhoneNumber }) => {
  return (
    <div className="mt-2">
      <input
        className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
        id="inline-full-name"
        type="text"
        name="receiverName"
        onChange={handleChange}
        placeholder="Name"
      />
      <ErrorInputComponent error={errors.receiverName} />
      <PhoneInput
        name="receiverPhoneNumber"
        country={"ng"}
        containerStyle={{
          border: "1px solid gray",
          marginTop: "10px",
          paddingTop: "5px",
          paddingBottom: "5px",
          borderRadius: "2px",
        }}
        inputStyle={{
          border: "none",
        }}
        required
        onChange={(e) => setReceiverPhoneNumber(e)}
        placeholder={"Phone Number"}
      />
      <ErrorInputComponent error={errors.receiverPhoneNumber} />
      <input
        className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
        id="inline-full-name"
        type="email"
        name="receiverAddress"
        onChange={handleChange}
        placeholder="Receiver's Address"
      />
      <ErrorInputComponent error={errors.receiverAddress} />
    </div>
  );
};

const SoftCopyView = ({
  errors,
  handleChange,
  values,
  setParentPhoneNumber,
}) => {
  const handleOnChange = (value) => {
    setParentPhoneNumber(value);
  };

  return (
    <div>
      <div className="mt-5">
        <div className="font-bold">Parent's Details</div>
        <input
          className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
          id="inline-full-name"
          type="name"
          name="parentName"
          onChange={handleChange}
          placeholder="Parent name"
        />
        <ErrorInputComponent error={errors.parentName} />

        <PhoneInput
          name="parentPhoneNumber"
          country={"ng"}
          containerStyle={{
            border: "1px solid gray",
            marginTop: "10px",
            paddingTop: "5px",
            paddingBottom: "5px",
            borderRadius: "2px",
          }}
          inputStyle={{
            border: "none",
          }}
          required
          onChange={handleOnChange}
          placeholder={"Phone Number"}
        />
      </div>
      <div className="mt-3">
        <div className="font-bold">Reason for Processing Transcript</div>
        <textarea
          className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
          id="inline-full-name"
          type="textarea"
          name="reason"
          rows={5}
          placeholder="Reason"
          onChange={handleChange}
        />
        <ErrorInputComponent error={errors.reason} />
      </div>
      <div className="mt-3">
        <div className="font-bold">Transcript Delivery</div>
        <TranscriptDelivery
          name={"transcriptDelivery"}
          handleChange={handleChange}
        />
        <div className="mt-2">
          <input
            className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="name"
            name="deliveryName"
            onChange={handleChange}
            placeholder="Name"
          />
          <ErrorInputComponent error={errors.deliveryName} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="number"
            name={
              values.transcriptDelivery === "ETX" ? "ddr" : "referenceNumber"
            }
            onChange={handleChange}
            placeholder={
              values.transcriptDelivery === "ETX" ? "DDR" : "Reference Number"
            }
          />
          <ErrorInputComponent error={errors.referenceNumber} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="email"
            name="receiverEmail"
            onChange={handleChange}
            placeholder="Receiver's Email"
          />
          <ErrorInputComponent error={errors.receiverEmail} />
        </div>
      </div>
    </div>
  );
};

export default function TranscriptOfficial() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [documentFee, setDocumentFee] = useState(0);
  const [alumniFee, setAlumniFee] = useState(0);
  const [parentPhoneNumber, setParentPhoneNumber] = useState("");
  const [receiverPhoneNumber, setReceiverPhoneNumber] = useState("");
  const [deliveryPhoneNumber, setDeliveryPhoneNumber] = useState("");
  const [documentFeeLoading, setDocumentFeeLoading] = useState(false);

  const account_type = TokenHelpers.getFromStorage("account_type");
  const account_path = getAccountPathByName(account_type);

  const {
    documentInstruction: {
      instructions,
      processingFeeLoading,
      instructionLoading,
    },
  } = useSelector(({ documentReducer }) => ({
    documentInstruction: documentReducer,
  }));

  useEffect(() => {
    dispatch(fetchDocumentInstructions("TRANSCRIPT_OFFICIAL"));
    getDocumentFee("TRANSCRIPT_OFFICIAL", "HARD_COPY", "LOCAL");
    // dispatch(getAllCountries());
  }, []);

  const getDocumentFee = (feeType, documentFormat, transcriptType) => {
    setDocumentFeeLoading(true);
    transcriptType = documentFormat === "SOFT_COPY" ? "LOCAL" : transcriptType;
    axios
      .get(
        `/api/services/v1/fees/type/${feeType}/${documentFormat}/${transcriptType}`
      )
      .then((res) => {
        if (res?.data !== undefined) {
          if (Object.keys(res?.data).length) {
            setDocumentFee(res.data.fee);
          }
        }
        setDocumentFeeLoading(false);
      });
  };

  const validationSchema = Yup.object({
    parentName: Yup.string().required("Parent's name is required"),
    reason: Yup.string().required("Reason is required"),
    deliveryName: Yup.string().when("transcriptType", {
      is: "FOREIGN",
      then: Yup.string().required("Delivery name is required"),
    }),
    // receiverEmail: Yup.string().when("transcriptType", {
    //   is: "FOREIGN",
    //   then: Yup.string()
    //     .email("Field should contain a valid e-mail")
    //     .max(255)
    //     .required("Receiver email is required"),
    // }),
    // referenceEmail:
    // Yup.string().when("transcriptType", {
    //   is: "FOREIGN",
    //   then:

    // Yup.string()
    //   .email("Field should contain a valid e-mail")
    //   .max(255)
    //   .required("Reference email is required"),
    // }),
    // referenceNumber: Yup.number().when("transcriptDelivery", {
    //   is: "WES",
    //   then: Yup.string().required("Reference number is required"),
    // }),
    // referenceNumber: Yup.number().when("transcriptDelivery", {
    //   is: "OTHERS",
    //   then: Yup.string().required("Reference number is required"),
    // }),

    ddr: Yup.string().when("transcriptDelivery", {
      is: "ETX",
      then: Yup.string().required("DDR number is required"),
    }),
  });

  const { handleSubmit, handleChange, values, errors, resetForm } = useFormik({
    initialValues: {
      referenceNumber: "",
      ddr: "",
      transcriptDelivery: "WES",
      documentFormat: "HARD_COPY",
      deliveryType: "DROP_OFF",
      documentType: "TRANSCRIPT_OFFICIAL",
      parentPhoneNumber: parentPhoneNumber,
      receiverPhoneNumber: receiverPhoneNumber,
      receiverAddress: "",
      parentName: "",
      reason: "",
      transcriptType: "LOCAL",
      receiverName: "",
      deliveryName: "",
      receiverEmail: "",
    },
    validationSchema,
    onSubmit(values) {
      const softCopyPayload = {
        transcriptType: values.transcriptType,
        ddr: values.ddr,
        documentType: "TRANSCRIPT_OFFICIAL",
        deliveryType: values.deliveryType,
        documentFormat: values.documentFormat,
        transcriptDelivery: values.transcriptDelivery,
        parentPhoneNumber: parentPhoneNumber,
        receiverPhoneNumber: receiverPhoneNumber,
        parentName: values.parentName,
        reason: values.reason,
        receiverAddress: values.receiverAddress,
        dropOffAddress: {
          locationAddress: values.receiverName,
        },
        transcriptDeliveryDto: {
          receiverEmail: values.receiverEmail,
          deliveryName: values.deliveryName,
          referenceNumber: values.referenceNumber,
          receiverAddress: values.receiverAddress,
          ddr: values.ddr,
          deliveryPhoneNumber: deliveryPhoneNumber,
        },
      };
      const hardCopyPayload = {
        transcriptType: values.transcriptType,
        documentType: "TRANSCRIPT_OFFICIAL",
        deliveryType: values.deliveryType,
        documentFormat: values.documentFormat,
        transcriptDelivery: values.transcriptDelivery,
        parentPhoneNumber: parentPhoneNumber,
        receiverPhoneNumber: receiverPhoneNumber,
        parentName: values.parentName,
        reason: values.reason,
        transcriptType: values.transcriptType,
        dropOffAddress: {
          locationAddress: values.receiverName,
        },
        transcriptDeliveryDto: {
          deliveryName: values.deliveryName,
          referenceNumber: values.referenceNumber,
          receiverAddress: values.receiverAddress,
          ddr: values.ddr,
          deliveryPhoneNumber: deliveryPhoneNumber,
        },
      };
      const payload =
        values.documentFormat === "HARD_COPY"
          ? hardCopyPayload
          : softCopyPayload;

      const navigateLink = () =>
        history.push({
          state: payload,
          pathname: `/dashboard${account_path}document-processing/payment`,
        });
      console.log("payload ", payload);
      dispatch(getDocumentProcessingFee(payload, navigateLink));
    },
  });

  useEffect(() => {
    getDocumentFee(
      "TRANSCRIPT_OFFICIAL",
      values.documentFormat,
      values.transcriptType
    );
  }, [values.documentFormat, values.transcriptType]);

  const buttonLoadState =
    processingFeeLoading === Loading.FETCHING || documentFeeLoading;
  const loadState = false;

  const InstructionComponent = ({ instruction }) => {
    return (
      <li>
        {instruction?.instruction}
        <span className="font-bold">
          {instruction?.costType === "ALUMNI_FEE" ? " N" + alumniFee : null}
          {instruction?.costType === "TRANSCRIPT_OFFICIAL"
            ? " N" + documentFee
            : null}
        </span>
      </li>
    );
  };

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <>
          <div className="overflow-hidden">
            <div className=" doc_processing_color h-44 px-2 pt-3">
              <TopNav />
              <div className="transcript_header">Transcript Official</div>
              <div className="text-md w-2/3">
                Get your certificate and other necessary documents easily and
                fast
              </div>
            </div>

            <div className="px-2 md:mx-20 mt-2 md:mt-10">
              <p className="font-semibold text-lg  ">Requirements:</p>
              <>
                {instructionLoading || documentFeeLoading ? (
                  <div>Loading....</div>
                ) : (
                  <div className="px-4">
                    <ul className="space-y-1 max-w-md list-disc list-inside">
                      {instructions.map((instruction, index) => {
                        return (
                          <InstructionComponent
                            instruction={instruction}
                            key={index}
                          />
                        );
                      })}
                    </ul>
                  </div>
                )}
              </>
            </div>
            <div className="md:flex md:flex-column md:justify-center">
              <div className="px-2 md:w-1/2 mt-0">
                <form className="p-0">
                  <div className="px-0 py-4">
                    <div className="mb-0">
                      <p className="font-bold">Transcript Format</p>
                      <CopyTypeComponent
                        handleChange={handleChange}
                        name={"documentFormat"}
                        // handleReset={resetForm}
                      />
                    </div>
                    {values.documentFormat === "SOFT_COPY" && (
                      <SoftCopyView
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        setParentPhoneNumber={setParentPhoneNumber}
                      />
                    )}
                    {values.documentFormat === "HARD_COPY" && (
                      <HardCopyView
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        setParentPhoneNumber={setParentPhoneNumber}
                        setReceiverPhoneNumber={setReceiverPhoneNumber}
                        setDeliveryPhoneNumber={setDeliveryPhoneNumber}
                      />
                    )}
                    <>
                      <p className="mt-5">
                        <span className="font-bold">N.B*</span>You are required
                        to pay a fee of
                        <span className="font-bold"> N{documentFee}</span> for
                        transcript processing
                      </p>
                    </>
                  </div>
                </form>
                <ButtomButton
                  name={"Next"}
                  func={handleSubmit}
                  setModal={setModal}
                  loading={buttonLoadState}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
